  <!--<section class="py-20">
  <div class="col-span-1 md:px-10 px-4">
        <h2 class="text-2xl font-bold">Suscripción Observada</h2>

        <p class="text-2xl font-light py-10"> Gracias por elegir Argenfil. <br> <br> Desafortunadamente no hemos podido
            realizar la suscripción de su equipo
            debido a que no cumple con los requisitos mínimos establecidos por la empresa. <br> <br> Un representante se
            pondrá en contacto para brindarle una solución.</p>
        <p class="text-2xl font-light py-10">Muchas gracias</p>
        <button (click)="volver()"
            class="bg-secondary text-sm font-medium px-4 py-1 rounded-full text-white flex items-center mx-auto">Volver
            al sitio <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg></button>
    </div>
    <div class="col-span-1 hidden md:block">
        <img src="assets/thanks.png" class="mx-auto w-1/2" alt="">
    </div>
</section>-->
<section class="py-20">
    <div class="flex text-primary text-center items-center shadow-lg m-20 mt-0 p-20 justify-center">
      <div class="mr-6">
        <mat-icon class="text-orange-500" style="font-size: 120px; width: 120px; height: 120px;">info</mat-icon>
      </div>
      <div class="">
        <h1 class="text-3xl md:text-3xl font-bold pb-3">¡Gracias por confiar en Everfull!</h1>
        <p class="text-md font-light mb-10">Estamos procesando tu solicitud de suscripción. <br> 
            Necesitamos verificar algunos datos para garantizar el mejor servicio posible.
        </p>
        <p class="font-bold pb-5">Te contactaremos muy pronto para continuar con tu instalación.</p>
        <button (click)="volver()" class="bg-secondary hover:bg-primary text-sm font-medium px-4 py-1 rounded-full text-white flex items-center mx-auto transition duration-300 ease-in-out">Volver</button>
      </div>    
    </div>
</section>